// extracted by mini-css-extract-plugin
export default {"maindiv1":"adstyles_maindiv1__Vek-8","maindiv2":"adstyles_maindiv2__1LVU3","maindiv3":"adstyles_maindiv3__1PpMT","imagelogo":"adstyles_imagelogo__WpzoT"};